import gql from 'graphql-tag';

const CREATE_MEDIA_ADMIN = gql`
  mutation createMedia(
    $url: String!
    $mediatype: MediaType!
    $key: String!
    $width: Int
    $height: Int
    $size: Int
    $name: String
    $fileType: FileType
  ) {
    createMedia(
      data: {
        url: $url
        key: $key
        type: $mediatype
        width: $width
        height: $height
        size: $size
        name: $name
        fileType: $fileType
      }
    ) {
      id
      url
      key
      width
      height
      fileType
      size
      name
    }
  }
`;

export default CREATE_MEDIA_ADMIN;
